import AbsSection from '../common/AbsSection';
import MoviePlayer from '../common/MoviePlayer';
import { TweenMax } from 'gsap/all';
import { getDatasWithOption } from '../common/service';
import { isObject } from '../common/Utils';

class SecGarden extends AbsSection {

    constructor(_store = {}, _el = '') {
        super('garden', _store, _el);

        const watchStampLength = this.watch(this.store.getState, 'stampLength');
        this.store.subscribe(watchStampLength(this.setGardenRewardStamp.bind(this)));

        $('#layer-garden-reward .reward .reward-preorder-wrap').toggle(false);
        TweenMax.set('#layer-garden-reward .reward .reward-preorder-wrap', { autoAlpha: 0, y: 30 });

        const watchInviteUser = this.watch(this.store.getState, 'isInviteUser');
        this.store.subscribe(watchInviteUser(this.setInviteUser.bind(this)));

        const _ = this;

        _._$myUrlInput = null;
        _._$shareWrap = $('.invitation-share', '#layer-garden-invitation');

    }

    setting() {
        this.videoList = {
            mobile: {
                loop: {
                    url: this.moviepath + '/new/MO_garden_low.mp4',
                    width: 1920*0.7, height: 1080*0.7
                }
            },
            tablet: {
                loop: {
                    url: this.moviepath + '/new/MO_garden_low.mp4',
                    width: 1920, height: 1080
                }
            },
            pc: {
                loop: {
                    url: this.moviepath + '/new/PC_garden_low.mp4',
                    width: 2276, height: 1280
                }
            }
        }[this.store.getState().config.device];

        this.vidLoop = new MoviePlayer({
            url: this.videoList.loop.url,
            parentNode: $(this.el + ' .vid .draggable'),
            movieW: this.videoList.loop.width, movieH: this.videoList.loop.height,
            selector: 'secGardenloop', videoControl: 'preload="auto" playsinline muted="muted" loop',
            isBgType: false,
            stateCallback: (state) => { }
        });

        let cssobj = { width: this.videoList.loop.width };
        if (this.$win.width() > this.videoList.loop.width) {
            cssobj['margin-left'] = -this.videoList.loop.width / 2;
            cssobj['left'] = '50%';
        }
        this.vidLoop.node.css(cssobj);

        this.drag = Draggable.create(this.el + " .drag-wrap", { type: "scroll", edgeResistance: 1, throwProps: true })[0];


        const _ = this;
        _._$myUrlInput = $('.my-url-wrap .my-url-active', '#layer-garden-invitation');
        _._setShareBtns();

        this.reset();
    }

    addEvents() {
        $(this.el + ' [data-stamp]').on('click', e => {
            const stampData = parseInt(e.currentTarget.dataset.stamp);
            if (stampData) {
                this.store.dispatch(this.actions.addStamp(stampData));
            }
        });

        $('#container').on('layer.open', (e, layerSel) => {
            if (layerSel === '#layer-garden-reward' && this.store.getState().config.isLogin) {
                this.store.dispatch(this.actions.loadStamp());
            }
        });

        if (this.store.getState().config.device === 'mobile') {
            $(this.el + ' .spot-list button.btn-spot').on('click', e => {
                $(this.el + ' .spot-list button.btn-spot-layer').hide();
                $(e.currentTarget).siblings('.btn-spot-layer').show();
            });
        }
    }

    setGardenRewardStamp(_newVal) {
        const stampList = $('.reward-stamps-list .stamps-icon').removeClass('is-active');
        if (stampList.length < 1) return;
        for (let i = 0; i < this.store.getState().stampLength; i++) {
            $(stampList[i]).addClass('is-active');
        }
    }

    setInviteUser(_newVal) {
        $('#layer-garden-reward .reward .reward-preorder-wrap').toggle(_newVal);
        TweenMax.to('#layer-garden-reward .reward .reward-preorder-wrap', 1, { autoAlpha: 1, y: 0 });
    }

    _setShareBtns() {
        const _ = this;

        if (!isObject(window._shareData2)) {
            // not login
        } else {
            _._$myUrlInput.attr('placeholder', window._shareData2.url);

            $('#layer-garden-invitation').on('click', '.share-kakaotalk', function (evt) {
                _._callShareSnsApi('kakaotalk');
            });

            $('#layer-garden-invitation').on('click', '.share-kakaostory', function (evt) {
                _._callShareSnsApi('kakaostory');
            });

            $('#layer-garden-invitation').on('click', '.share-facebook', function (evt) {
                _._callShareSnsApi('facebook');
            });

            $('#layer-garden-invitation').on('click', '.share-twitter', function (evt) {
                _._callShareSnsApi('twitter');
            });
        }
    }

    _callShareSnsApi(snsName) {
        console.log('call share sns api - snsName :', snsName);

        getDatasWithOption({
            type: 'POST',
            dataType: 'json',
            url: '/event/snsShareLog',
            data: {
                eventCode: '200624_inviteFriends',
                snsName: snsName
            }
        },
            (data, textStatus, jqXHR) => {
                console.log(
                    'success data, textStatus, jqXHR :',
                    data,
                    textStatus,
                    jqXHR
                );
            },
            (jqXHR, textStatus, errorThrown) => {
                console.log(
                    'fail jqXHR, textStatus, errorThrown :',
                    jqXHR,
                    textStatus,
                    errorThrown
                );
            }
        );
    }

    setAniObj() {
        super.setAniObj();
        TweenMax.set(this.el + ' .title', { autoAlpha: 0, scale: 1.3 });
        TweenMax.set(this.vidLoop.node, { autoAlpha: 0, scale: 1.3 });
        TweenMax.set(this.el + ' .btn-spot', { scale: 0 });
    }

    titleAni() {
        $(this.el + ' .title').show();
        TweenMax.to(this.el + ' .title', 3.5, { autoAlpha: 1, scale: 1 });
        TweenMax.to(this.vidLoop.node, 1.7, { autoAlpha: 1, scale: 1, ease: Quint.easeOut });
        TweenMax.staggerTo(this.el + ' .btn-spot', 0.5, { scale: 1, ease: Quint.easeOut, delay: 0.7 }, 0.2);

        TweenMax.fromTo(this.el + ' .noti-drag', 0.8, 
            { autoAlpha: 1, display: 'block' }, 
            { autoAlpha: 0, display: 'none', delay: 1.5 }
        );
    }

    start() {
        super.start();
        this.store.dispatch(this.actions.addSecCookies(this.name));
        this.vidioReset(this.vidLoop, 2, true).play(0);
    }

    end() {
        super.end();
        TweenMax.to(this.el + ' .btn-spot', 0.3, { scale: 0, ease: Quint.easeIn });

        this.vidioReset(this.vidLoop, 1, true).pause();

        TweenMax.to(this.vidLoop.node, 1.3, {
            autoAlpha: 0, scale: 1.3, ease: Expo.easeIn, onComplete: () => {
                this.transitionEnd();
            }
        });
    }

    reset() {
        super.reset();
        this.vidioReset(this.vidLoop).pause();
    }
} // end of class
export default SecGarden;